import React, { useContext, useMemo } from 'react'

import { FRONT_PAGE_OFFERS_TYPES } from 'constants/offerList'
import useOfferList from 'hooks/Offers/useOfferList'
import TopPicksForMeOfferCarouselSection from './TopPicksForMeOfferCarouselSection'
import GeoContext from 'contexts/geoContext'
import { EmptyArray, take } from 'lib/array/arrayUtils'

interface Props {
  excludedOfferIds?: Array<string>
  trackingPageSource: string
  trackingUiTouchpoint: string
  fetching?: boolean;
}

function TopPicksForMeFrontPageOfferCarousel(props: Props) {
  const {
    excludedOfferIds = EmptyArray,
    trackingPageSource,
    trackingUiTouchpoint,
    fetching,
  } = props

  const { currentRegionCode } = useContext(GeoContext)

  const offerListFilters = useMemo(() => {
    return {
      offerTypes: FRONT_PAGE_OFFERS_TYPES(currentRegionCode),
      frontPageVisibleOnly: true,
      excludeConnectionTours: true,
    }
  }, [currentRegionCode])

  const offerList = useOfferList(offerListFilters, { excludedIds: excludedOfferIds })
  const offerIds = take(offerList.offerIds, 15)

  return (
    <TopPicksForMeOfferCarouselSection
      heading={<>Today's <i>exclusive</i> offers</>}
      offerIds={offerIds}
      lereVersion="N/A"
      trackingPageSource={trackingPageSource}
      trackingUiTouchpoint={trackingUiTouchpoint}
      fetching={fetching}
    />
  )
}
export default TopPicksForMeFrontPageOfferCarousel
